// CustomMUIIcon.js
import React from "react";
import { Tooltip } from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import SchoolIcon from '@mui/icons-material/School';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CreateIcon from '@mui/icons-material/Create';
import InfoIcon from '@mui/icons-material/Info';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import LaunchIcon from '@mui/icons-material/Launch';
import DoneIcon from '@mui/icons-material/Done';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import {
  Add as AddIcon,
  Search as SearchIcon,
  ViewModule as ViewModuleIcon,
  ViewList as ViewListIcon,
} from "@mui/icons-material"
import {
  Instagram, MoreVert, ArrowForward, Event,
  CurrencyRupee,
  EventBusy,
  Group, ListAlt
} from "@mui/icons-material"
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import SensorsIcon from '@mui/icons-material/Sensors';
import ClearIcon from '@mui/icons-material/Clear';

const iconMap = {
  dashboard: HomeIcon,
  calender: CalendarMonthIcon,
  tag: LocalOfferIcon,
  news: NewspaperIcon,
  scholer: SchoolIcon,
  add: AddIcon,
  search: SearchIcon,
  view: ViewModuleIcon,
  viewlist: ViewListIcon,
  copy: ContentCopyIcon,
  close: VisibilityOffOutlinedIcon,
  addbox: AddBoxOutlinedIcon,
  delete: DeleteOutlineIcon,
  edit: EditOutlinedIcon,
  image: ImageOutlinedIcon,
  open: OpenInNewIcon,
  tick: TaskAltIcon,
  cancel: CancelOutlinedIcon,
  insta: Instagram,
  menu: MoreVert,
  arrowright: ArrowForward,
  event: Event,
  rupee: CurrencyRupee,
  busyEvent: EventBusy,
  groupUser: Group,
  people: Group,
  list: ListAlt,
  create: CreateIcon,
  info: InfoIcon,
  lock: LockOutlinedIcon,
  right: ChevronRightIcon,
  launch: LaunchIcon,
  done: DoneIcon,
  facebook: FacebookIcon,
  youtube: YouTubeIcon,
  offer: NewReleasesIcon,
  error: ErrorOutlineIcon,
  download : FileDownloadOutlinedIcon,
  accessTime : AccessTimeIcon,
  draft : InsertDriveFileOutlinedIcon,
  viewData :VisibilityOutlinedIcon,
  assignment: AssignmentOutlinedIcon,
  check: CheckCircleOutlineIcon,
  shipping:LocalShippingOutlinedIcon,
  sensor: SensorsIcon ,
  clear :ClearIcon
};

const ReusableMuiIcons = ({ name, tooltip = "", fontSize = 'small', ...props }) => {
  const IconComponent = iconMap[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" is not defined in iconMap.`);
    return null;
  }

  const icon = <IconComponent fontSize={fontSize}  {...props} />;

  return tooltip ? <Tooltip title={tooltip} arrow>{icon}</Tooltip> : icon;
};

export default ReusableMuiIcons;
